import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getCamiones,
  deleteCamion,
  getCamionById,
} from "../helpers/rutaCamiones";
import ModalCamion from "./ModalCamion";
import "../css/tableclientes.css";

const TableCamiones = () => {
  const [camiones, setCamiones] = useState({
    data: {},
    loading: true,
  });

  const [camion, setCamion] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaCamiones();
  }, []);

  const consultaCamiones = () => {
    getCamiones().then((datos) => {
      console.log("📦 Camiones:", datos);
      setCamiones({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaCamiones();
  };

  const handleShow = () => setShow(true);

  const modificaCamion = (id) => {
    getCamionById(id).then((resp) => {
      if (resp.ok) {
        setCamion(resp.camion); // ✅ ahora sí solo el objeto camion
        handleShow();
      } else {
        console.error("❌ Error al obtener camion:", resp.error);
      }
    });
  };

  const eliminarCamion = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el camion?");
    if (confirmar) {
      deleteCamion(id).then(() => {
        consultaCamiones();
      });
    }
  };

  return (
    <div className="table-container">
      {!camiones.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Vehiculo</th>
                  <th className="dom">Patente</th>
                </tr>
              </thead>
              <tbody>
                {camiones.data.camiones.map((camion) =>
                  camion.activo ? (
                    <tr key={camion._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaCamion(camion._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarCamion(camion._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{camion.codcam}</td>
                      <td>{camion.camion}</td>
                      <td>{camion.patente}</td>
                      {/* <td>{camion.localidad?.localidad || "-"}</td> */}
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalCamion
            show={show}
            handleClose={handleClose}
            camion={camion}
          />
        </>
      )}
    </div>
  );
};

export default TableCamiones;
